import HomepageTemplate from 'gatsby-theme-carbon/src/templates/Homepage';
import * as React from 'react';
export default {
  HomepageTemplate,
  React
};